export default __webpack_public_path__ + "static/media/media_type_audio.0ddb3815.svg";